import React, { useState, useEffect } from 'react'
import MainContext from './../createContext/MainContext'
import { useReducer } from 'react'
import { SERVER_URL } from '../../../serverAddr'
import axios from "../../customAxios"

const AUTH_KEY = {
    headers: { Authorization: "Basic " + btoa("ShowCaseGuest" + ":" + "Sima@Camunda") }
}
export const DEFULY_VAL = {
    statusId: ['WeClosed', 'WeInProgress']
}
const MainProvider = (props) => {


    const [valFilter, setValFilter] = useState(DEFULY_VAL)
    const [hoverBoxShow, setHoverBoxShow] = useState(false)

    function getAllFrakhan() {
        return new Promise((resolve, reject) => {
            axios.get(`${SERVER_URL}/rest/s1/Farakhan/FarakhanWindow`).then(res => {
                const farakhanInfoList = res.data.farakhanInfoList.reverse()
                return resolve({
                    ...res.data, farakhanInfoList: [ ...farakhanInfoList ]
                })
            }).catch(err => reject("... لطفا دوباره سعی کنید"))
        })
    }


    function getEnum() {
        return new Promise((resolve, reject) => {
            axios.get(`${SERVER_URL}/rest/s1/sortdata/FindEnum?optionIndicator=N&enumTypeId=Expertise`).then(res => {
                return resolve(res.data)
            }).catch(err => reject("... لطفا دوباره سعی کنید"))
        })
    }


    function getStatus() {
        return new Promise((resolve, reject) => {
            axios.get(`${SERVER_URL}/rest/s1/Farakhan/StatusItem?statusTypeId=WorkEffort&statusCode=Show`).then(res => {
                return resolve(res.data)
            }).catch(err => reject("... لطفا دوباره سعی کنید"))
        })
    }

    function preViewFarakhanInfo(workEffortId) {
        return new Promise((resolve, reject) => {
            axios.get(`${SERVER_URL}/rest/s1/Farakhan/PreViewFarakhanInfo?workEffortId=${workEffortId}`).then(res => {
                return resolve(res.data)
            }).catch(err => reject("... لطفا دوباره سعی کنید"))
        })
    }

    function getFarakhanInfo(filterObj) {


        return new Promise((resolve, reject) => {
            axios.post(`${SERVER_URL}/rest/s1/Filter/FarakhanFiltering`, {
                inputMap: {
                    ...valFilter,
                    ...filterObj,

                }
            }).then(res => {
                return resolve(res.data.farakhanInfoDicList)
            }).catch(err => reject("... لطفا دوباره سعی کنید"))
        })
    }


    const [state, dispatch] = useReducer((state, actions) => {
        switch (actions.type) {
            case 'getAllFrakhan':
                return { ...state, ...actions.data }
            case 'getEnum':
                return { ...state, ...actions.data }
            case 'getStatus':
                return { ...state, ...actions.data }
            case 'preViewFarakhanInfo':
                return { ...state, ...actions.data }
            case 'getFarakhanInfo':
                return { ...state, farakhanInfoList: [...actions.data] }
            default:
                return state;
        }
    }, {})



    const preViewFarakhanInfoCallBack = (workEffortId) => {
        preViewFarakhanInfo(workEffortId).then(res => {
            dispatch({
                type: "preViewFarakhanInfo",
                data: res
            })
        })
    }
    const getFarakhanInfoCallBack = (fillterObj) => {

        getFarakhanInfo(fillterObj).then(res => {
            dispatch({
                type: "getFarakhanInfo",
                data: res
            })
        })
    }





    useEffect(() => {
        getAllFrakhan().then(res => {
            dispatch({
                type: "getAllFrakhan",
                data: res
            })
        })

        getEnum().then(res => {
            dispatch({
                type: "getEnum",
                data: res
            })
        })
        getStatus().then(res => {
            dispatch({
                type: "getStatus",
                data: res
            })
        })

    }, [])


    return (
        <MainContext.Provider
            value={{
                state: state,
                hoverBoxShow: hoverBoxShow,
                setHoverBoxShow: setHoverBoxShow,
                preViewFarakhanInfoCallBack: preViewFarakhanInfoCallBack,
                getFarakhanInfoCallBack: getFarakhanInfoCallBack,
                setValFilter,
                valFilter
            }}>
            {props.children}

        </MainContext.Provider>
    )
}

export default MainProvider